import Cookies from "js-cookie";

export function setCookie(token) {
  console.log(token, "token");
  Cookies.set("token", JSON.stringify(token), { expires: 1 });
}

export function getCookie(value) {
  // if (Cookies.get(value)) {
  //   return JSON.parse(Cookies.get(value));
  // }
  // return null;


  const cookie = Cookies.get(value);

  if (!cookie) return null;

  try {
    return JSON.parse(cookie);
  } catch (err) {
    // fallback for plain string cookies like "Authorized"
    return cookie;
  }
}

export function removeCookie(value) {
  Cookies.remove(value);
}